import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";

import {
  getMetricForColumn,
  selectFormat,
  Error,
  sortNumeric,
} from "./../Utils/Utils.js";

class DonationsTableSource extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable = (data) => {
    const { cells, title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const columns = [
      {
        dataField: "source",
        text: "Source",
        style: { width: "80px", minWidth: "80px" },
        csvFormatter: (cell, row) => row && row.source,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "source_detail",
        text: "Source Detail",
        style: { width: "80px", minWidth: "80px" },
        csvFormatter: (cell, row) => row && row.source_detail,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "donations",
        text: "Donations",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "dollars_donated",
        text: "Dollars Donated",
        style: { width: "80px", minWidth: "80px" },
        formatExtraData: { type: "currency" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("svc_currency", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) =>
        selected_columns.push(columns.find((o) => o.dataField === cell))
      );
    }
    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.data;

    return data.hasData === false ? (
      <Error minHeight={360} />
    ) : (
      this.renderTable(data)
    );
  }
}

export default DonationsTableSource;
